@use '../../../styles/Constants.scss' as Constants;

.temporary-employee-list {

	&__temp-icon {
		font-size: Constants.$val-fontSizeBig;
		margin-right: Constants.$val-spacing-xs;
		align-content: center;
	}
}